import AddYourCompany from "assets/navigationIcons/add-company.svg?react";
import CreditLimitRequest from "assets/navigationIcons/creditLimitRequests.svg?react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { ADD_COMPANY, BOOK_MEETING, REGISTER_FOR_FINANCING } from "codes";
import type { TFunction } from "i18next";
import { menuStyling as styling } from "styles/theme";

/** Presales / financing stepper: only Add company + Request Financing until fully onboarded. */
export const getPresalesMenuItems = (t: TFunction) => [
  {
    title: `${t("add-your-company")}`,
    icon: AddYourCompany,
    ...styling,
    link: ADD_COMPANY,
  },
  {
    title: "Request Financing",
    icon: CreditLimitRequest,
    ...styling,
    link: REGISTER_FOR_FINANCING,
  },
  {
    title: `${t("Book a meeting")}`,
    icon: CalendarMonthIcon,
    ...styling,
    link: BOOK_MEETING,
  },
];
